import { FC } from 'react';

import { ImageFade } from '@rikstv/play-common/src/components/imageFade/ImageFade';
import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { Link } from '@rikstv/play-common/src/router/Link';
import { commonRoutes } from '@rikstv/play-common/src/router/router.path';
import {
  bbcNordicSlug,
  maxSlug,
  nordiskFilmSlug,
  nrkSlug,
  skyShowtimeSlug,
  tv2playSlug,
  viaplaySlug,
} from '@rikstv/play-common/src/utils/displayNames/slugs';
import { H2 } from '@rikstv/shared-components';

import routerPath from '../../../../common/router/router.path';

import styles from './Services.module.css';

const Services: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <H2 className={styles.title}>Strøm innholdet fra de største leverandørene</H2>
        <div className={styles.services}>
          <Link to={commonRoutes.collections({ slug: maxSlug })}>
            <ImageFade src="https://static.rikstv.no/logopack/Max_square.svg" alt="Max" />
          </Link>
          <Link to={commonRoutes.collections({ slug: tv2playSlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/tv2playV4_logo.png?lossless=true"
              alt="TV 2 Play"
            />
          </Link>
          <Link to={commonRoutes.collections({ slug: viaplaySlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/viaplay_logo.png?lossless=true"
              alt="Viaplay"
            />
          </Link>
          <Link to={commonRoutes.collections({ slug: skyShowtimeSlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/skyshowtime_logo.png?lossless=true"
              alt="SkyShowtime"
            />
          </Link>
          <Link to={commonRoutes.collections({ slug: nrkSlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/nrktv_logo.png?lossless=true"
              alt="NRK TV"
            />
          </Link>
          <Link to={commonRoutes.collections({ slug: nordiskFilmSlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/nordiskfilm_logo.png?lossless=true"
              alt="Nordisk Film+"
            />
          </Link>
          <Link to={commonRoutes.collections({ slug: bbcNordicSlug })}>
            <ImageFade
              src="https://imageservice.rikstv.no/static/strim/images/frontpage/services/bbcnordic_logo.png?lossless=true"
              alt="BBC Nordic+"
            />
          </Link>
        </div>
        <LinkButton className={styles.link} buttonStyle="highlighted" withArrow to={routerPath.strommetjenester()}>
          <span>
            Les mer<span className={styles.hiddenOnSmallestScreen}> om strømmetjenestene</span>
          </span>
        </LinkButton>
      </div>
    </div>
  );
};

export default Services;
